import styled from 'styled-components';

const RadioButtonContent = styled.div<{ customBackground?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  min-width: 48px;
  padding-left: 8px;
  padding-right: 8px;
  border: 1px solid ${(p) => (p.customBackground ? p.customBackground : '#ccc')};
  border-radius: 4px;
  background-color: ${(p) =>
    p.customBackground ? p.customBackground : '#fafafa'};
`;

export default RadioButtonContent;
